var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g(_vm._b({staticClass:"back iconfont icon-back",class:_vm.pointClass,attrs:{"href":"javascript:;"},on:{"click":_vm.goToLastRoute}},'a',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }